import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { mapGetters } from 'vuex';

import ElementUI, { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import './assets/style/theme/index.css';
Vue.use(ElementUI);
Vue.prototype.$loading = Loading.service;

// 说明：echarts 改为按需引入，各图表组件内部通过 echarts/core 的 use() 注册所需模块，
// 这里不再 `import "echarts"` 全量引入，也不做全局 v-chart 注册（避免整包进入公共 chunk）
Vue.config.productionTip = false

// 全局注入页面权限，每个子组件可通过 this.$pagePermission 访问
Vue.mixin({
    computed: {
        ...mapGetters('permission', ['pagePermission']),
        $pagePermission() {
            const path = this.$route && this.$route.path;
            return this.pagePermission(path);
        }
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
